import * as R from 'ramda';
//////////////////////////////////////////////////

const getFormData = object => {
  // eslint-disable-next-line no-undef
  const formData = new FormData();

  R.compose(
    R.forEach(key => formData.append(key, R.prop(key, object))),
    R.keys,
  )(object);

  return formData;
};

const getParamsFromSearch = () => {
  const { search } = window.location;

  const params = new URLSearchParams(search);

  if (R.isNil(params)) return {};

  const allParams = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const key of params.keys()) {
    allParams[key] = params.get(key);
  }

  return allParams;
};

export {
  getFormData,
  getParamsFromSearch,
};
